const geoLocationEndpoints = {
    baseUrl: 'https://mlssoccer.com',
    geolocation: '/api/v1/geolocation',
};

export default geoLocationEndpoints;